<template>
  <div class="grid-content">
    <el-row>
      <el-col :md="24" :lg="12" :xl="12" class="dateBox">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="今天" name="first"></el-tab-pane>
          <el-tab-pane label="明天" name="second"></el-tab-pane>
          <el-tab-pane label="后天" name="third"></el-tab-pane>
          <el-tab-pane name="fourth">
            <span slot="label" style="width:100px;">
              <el-date-picker v-model="data" size="mini" type="date" :picker-options="startTime" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" @change="changedata" placeholder="选择日期" />
            </span>
          </el-tab-pane>
        </el-tabs>
        <ul>
          <div style="width: 500px;">
            <div v-for="(item, index) in meetTime" :key="index" style="width:40px; float:left;">
              <span v-if="item.start.split(':')[1] === '00'"
                style="width:30px; text-align: center;display: block; font-size: 12px;">{{ item.start }}</span>
              <li :class="{ bg: item.isSelect }"
                style="display: inline-block; text-align: center; line-height: 44px;position: relative"
                @click="handleTime(item, index)">
                <span v-if="!item.name" style="
                      position: absolute;
                      top: 0;
                      width: 100%;
                      height: 100%;
                      left: 0;">
                  <img v-if="item.isClick" src="../../../public/static/images/disable.png" style="width: 24px;" />
                </span>
                <span v-else :title="item.name" @click="tip(item)" style="background: #29d;
                      position: absolute;
                      top: 0;
                      width: 100%;
                      height: 100%;
                      left: 0;"></span>
              </li>
              <span v-if="item.start.split(':')[1] === '45'"
                style="width:30px; text-align: center;display: block; font-size: 12px;">{{ item.end }}</span>
            </div>
          </div>
        </ul>
      </el-col>
      <el-col :lg="1" :xl="1">
        <div style="width:100%;height:1px ;" />
      </el-col>
      <el-col :md="24" :lg="11" :xl="11">
        <!-- height="220" -->
        <el-table :data="tableData" style="width: 100%" height="230" :span-method="mergeLine"
          :header-cell-style="{ background: '#409eff', padding: '8px 0', color: '#fff' }" size="small" border>
          <el-table-column prop="creator_name" width="100" label="召集人" align="center"></el-table-column>
          <el-table-column prop="meeting_subject" label="会议主题" align="center"></el-table-column>
          <el-table-column label="预计时间" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.estimate_start_time.split(' ')[1] }} ~ {{ scope.row.estimate_end_time.split(' ')[1]}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="estimate_start_time" label="预计开始时间"></el-table-column>
          <el-table-column prop="estimate_end_time" label="预计结束时间"></el-table-column> -->
          <el-table-column prop="meeting_status" label="会议状态" width="100" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.meeting_status == 0">已预约</span>
              <span v-else-if="scope.row.meeting_status == 1">进行中</span>
              <span v-else-if="scope.row.meeting_status == 2">已结束</span>
              <span v-else-if="scope.row.meeting_status == 3">未进行</span>
              <span v-else-if="scope.row.meeting_status == 4">已取消</span>
              <span v-else-if="scope.row.meeting_status == 5">决议处理中</span>
              <!-- <span v-if="scope.row.meeting_status==6">会议待评分</span> -->
              <span v-else-if="scope.row.meeting_status == 7">已完成</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { parseTime, deepClone } from '@/utils/index'
import {
  meetings
} from '@/api/conferencebooking'
export default {
  props: ['roomid', 'isList'],
  data() {
    return {
      tableData: [],
      meetTime: [

        {
          id: 17,
          start: '08:00',
          end: '08:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 21,
          start: '09:00',
          end: '09:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 25,
          start: '10:00',
          end: '10:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 29,
          start: '11:00',
          end: '11:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 33,
          start: '12:00',
          end: '12:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 37,
          start: '13:00',
          end: '13:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 41,
          start: '14:00',
          end: '14:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 45,
          start: '15:00',
          end: '15:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 49,
          start: '16:00',
          end: '16:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 53,
          start: '17:00',
          end: '17:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 57,
          start: '18:00',
          end: '18:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 61,
          start: '19:00',
          end: '19:15',
          isSelect: false,
          isClick: false
        },
        // {
        //   id: 41,
        //   start: '20:00',
        //   end: '20:30',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 43,
        //   start: '21:00',
        //   end: '21:30',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 45,
        //   start: '22:00',
        //   end: '22:30',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 47,
        //   start: '23:00',
        //   end: '23:30',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 2,
        //   start: '00:30',
        //   end: '01:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 4,
        //   start: '01:30',
        //   end: '02:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 6,
        //   start: '02:30',
        //   end: '03:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 8,
        //   start: '03:30',
        //   end: '04:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 10,
        //   start: '04:30',
        //   end: '05:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 12,
        //   start: '05:30',
        //   end: '06:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 14,
        //   start: '06:30',
        //   end: '07:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 16,
        //   start: '07:30',
        //   end: '08:00',
        //   isSelect: false,
        //   isClick: false
        // },
        {
          id: 18,
          start: '08:15',
          end: '08:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 22,
          start: '09:15',
          end: '09:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 26,
          start: '10:15',
          end: '10:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 30,
          start: '11:15',
          end: '11:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 34,
          start: '12:15',
          end: '12:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 38,
          start: '13:15',
          end: '13:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 42,
          start: '14:15',
          end: '14:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 46,
          start: '15:15',
          end: '15:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 50,
          start: '16:15',
          end: '16:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 54,
          start: '17:15',
          end: '17:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 58,
          start: '18:15',
          end: '18:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 62,
          start: '19:15',
          end: '19:30',
          isSelect: false,
          isClick: false
        },

        {
          id: 19,
          start: '08:30',
          end: '08:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 23,
          start: '09:30',
          end: '09:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 27,
          start: '10:30',
          end: '10:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 31,
          start: '11:30',
          end: '11:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 35,
          start: '12:30',
          end: '12:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 39,
          start: '13:30',
          end: '13:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 43,
          start: '14:30',
          end: '14:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 47,
          start: '15:30',
          end: '15:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 51,
          start: '16:30',
          end: '16:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 55,
          start: '17:30',
          end: '17:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 59,
          start: '18:30',
          end: '18:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 63,
          start: '19:30',
          end: '19:45',
          isSelect: false,
          isClick: false
        },

        {
          id: 20,
          start: '08:45',
          end: '09:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 24,
          start: '09:45',
          end: '10:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 28,
          start: '10:45',
          end: '11:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 32,
          start: '11:45',
          end: '12:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 36,
          start: '12:45',
          end: '13:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 40,
          start: '13:45',
          end: '14:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 44,
          start: '14:45',
          end: '15:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 48,
          start: '15:45',
          end: '16:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 52,
          start: '16:45',
          end: '17:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 56,
          start: '17:45',
          end: '18:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 60,
          start: '18:45',
          end: '19:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 64,
          start: '19:45',
          end: '20:00',
          isSelect: false,
          isClick: false
        }

        // {
        //   id: 42,
        //   start: '20:30',
        //   end: '21:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 44,
        //   start: '21:30',
        //   end: '22:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 46,
        //   start: '22:30',
        //   end: '23:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 48,
        //   start: '23:30',
        //   end: '24:00',
        //   isSelect: false,
        //   isClick: false
        // }
      ],
      comparedTime: [],
      value1: '',
      activeName: 'first',
      data: '',
      startTime: {
        // 用于会议室列表的组件不限制时间选择
        disabledDate: time => {
          if (this.isList) {
            return null
          } else {
            const curDate = new Date()// 今天
            const preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000)// 昨天
            return time.getTime() <= preDate
          }
        }
      }
    }
  },
  created() {
    const nowDate = new Date().getTime()
    this.data = parseTime(nowDate, '{y}-{m}-{d}')
    const formateDate = parseTime(nowDate).split(' ')[1]
    const formateTime = formateDate.substr(0, 5).split(':')
    this.initIsClick(Number(formateTime[0] + formateTime[1]))
    const data = {
      estimate_start_time: this.data + ' 00:00:00',
      estimate_end_time: this.data + ' 23:59:59',
      room_id: this.roomid
    }
    this.getmeetingsearch(data, 1)
  },
  watch: {
    data(newValue, oldValue) {
      const data = {
        estimate_start_time: this.data + ' 00:00:00',
        estimate_end_time: this.data + ' 23:59:59',
        room_id: this.roomid
      }
      this.IsClick()
      this.getmeetingsearch(data, 1)
    },
    roomid: {
      handler(newValue, oldValue) {
        // 父组件param对象改变会触发此函数
        const data = {
          estimate_start_time: this.data + ' 00:00:00',
          estimate_end_time: this.data + ' 23:59:59',
          room_id: newValue
        }
        this.meetTime.forEach(v => {
          v.isClick = false
        })
        const nowDate = new Date().getTime()
        const formateDate = parseTime(nowDate).split(' ')[1]
        const formateTime = formateDate.substr(0, 5).split(':')
        this.initIsClick(Number(formateTime[0] + formateTime[1]))
        this.IsClick()
        this.getmeetingsearch(data, 1)
      },
      deep: true
    }
  },
  methods: {
    // 合并行
    mergeLine({ row, column, rowIndex, columnIndex }) {
      if (columnIndex !== 2) {
        if (row.cut) {
          return {
            rowspan: row.cut,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    initIsClick(data) {
      if (this.roomid === 19) {
        return
      }
      const formateTimeStr = data
      this.meetTime.forEach(v => {
        v.isSelect = false
        v.isClick = false
        const startTime = v.start.split(':')
        const startTimeStr = Number(startTime[0] + startTime[1])
        if (startTimeStr < formateTimeStr) {
          v.isClick = true
        }
      })
    },
    tip(val) {
      this.$alert(val.name, val.tab.tap.meeting_subject)
    },
    IsClick() {
      // 当时间是今天及之前，需处理disabled， 时间选择也需触发，今天、明天、后天面板的切换
      const time = new Date()
      const today = parseTime(time.getTime(), '{y}-{m}-{d}')
      const tomorrowDate = time.setDate(time.getDate() + 1)
      const tomorrow = parseTime((new Date(tomorrowDate)).getTime(), '{y}-{m}-{d}')
      const afterTomorrowDate = time.setDate(time.getDate() + 1)
      const afterTomorrow = parseTime((new Date(afterTomorrowDate)).getTime(), '{y}-{m}-{d}')

      if ((new Date(this.data)).getTime() === (new Date(today)).getTime()) {
        this.activeName = 'first'
      }
      if ((new Date(this.data)).getTime() === (new Date(tomorrow)).getTime()) {
        this.activeName = 'second'
      }
      if ((new Date(this.data)).getTime() === (new Date(afterTomorrow)).getTime()) {
        this.activeName = 'third'
      }
      if ((new Date(this.data)).getTime() > (new Date(afterTomorrow)).getTime()) {
        this.activeName = ''
      }
      if ((new Date(this.data)).getTime() < (new Date(today)).getTime()) {
        this.activeName = ''
      }
      this.meetTime.forEach(item => {
        if ((new Date(this.data)).getTime() < (new Date(today)).getTime()) {
          item.isClick = true
        }
        if ((new Date(this.data)).getTime() > (new Date(today)).getTime()) {
          item.isClick = false
        }
        item.isSelect = false
        if (item.name) {
          delete item.name
        }
        this.comparedTime = []
      })
      // this.meetTime.forEach(v => {
      //   if (this.activeName !== 'first') {
      //     v.isClick = false
      //   }
      //   v.isSelect = false
      //   if (v.name) {
      //     delete v.name
      //   }
      //   this.comparedTime = []
      // })
    },
    up(data) {
      if (this.roomid === 19) {
        return
      }

      for (let index = 0; index < data.length; index++) {
        const element = data[index]
        const datass = this.meetTime
        this.meetTime.forEach(v => {
          // if (v.name) {
          //   delete v.name;
          // }
          const startTime = v.start.split(':')
          const startTimeStr = Number(startTime[0] + startTime[1])
          if (
            element.startTime <= startTimeStr &&
            startTimeStr < element.endTime
          ) {
            v.isClick = true
            v.name = element.name
            v.tab = element
          }
        })
        this.meetTime = []
        this.meetTime = datass
      }
      console.log(data)
    },
    handleClick(tab, event) {
      if (tab.name === 'second') {
        var day1 = new Date()
        day1.setDate(day1.getDate() + 1)
        var year = day1.getFullYear() // 得到年份
        var month = day1.getMonth() // 得到月份
        var date = day1.getDate() // 得到日期
        this.data = year + '-' + (month + 1) + '-' + date
        this.initIsClick(0)
        const data = {
          estimate_start_time: this.data + ' 00:00:00',
          estimate_end_time: this.data + ' 23:59:59',
          room_id: this.roomid
        }
        this.getmeetingsearch(data, 2)
      }
      if (tab.name === 'first') {
        const nowDate = new Date().getTime()
        this.data =
          new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          new Date().getDate()
        const formateDate = parseTime(nowDate).split(' ')[1]
        const formateTime = formateDate.substr(0, 5).split(':')
        this.initIsClick(Number(formateTime[0] + formateTime[1]))
        const data = {
          estimate_start_time: this.data + ' 00:00:00',
          estimate_end_time: this.data + ' 23:59:59',
          room_id: this.roomid
        }
        this.getmeetingsearch(data, 1)
      }
      if (tab.name === 'third') {
        const day1 = new Date()
        day1.setDate(day1.getDate() + 2)
        const year = day1.getFullYear() // 得到年份
        const month = day1.getMonth() // 得到月份
        const date = day1.getDate() // 得到日期
        this.data = year + '-' + (month + 1) + '-' + date
        this.initIsClick(0)
        const data = {
          estimate_start_time: this.data + ' 00:00:00',
          estimate_end_time: this.data + ' 23:59:59',
          room_id: this.roomid
        }
        this.getmeetingsearch(data, 2)
      }
    },
    changedata() {
      // console.log(11111, this.data)
    },
    getmeetingsearch(data, type) {
      meetings(data)
        .then(response => {
          const dtays = []

          // this.tableData = response.data.meetings
          const cutData = response.data.meetings
          const moreData = []
          cutData.forEach(item => {
            if (item.meeting_type_id === 7) {
              item.cut = 2
              moreData.push(item)
              const json1 = JSON.parse(JSON.stringify(item))
              json1.estimate_end_time = item.night_eend_time
              json1.estimate_start_time = item.night_estart_time
              json1.cut = 0
              moreData.push(json1)
            } else {
              item.cut = 1
              moreData.push(item)
            }
          })

          this.tableData = moreData
          for (let index = 0; index < moreData.length; index++) {
            const element = moreData[index]
            const endinde = element.estimate_end_time.indexOf(':')
            const endTime =
              element.estimate_end_time.slice(endinde - 2, endinde) +
              element.estimate_end_time.slice(endinde + 1, endinde + 3)
            const startTime =
              element.estimate_start_time.slice(endinde - 2, endinde) +
              element.estimate_start_time.slice(endinde + 1, endinde + 3)
            const ss = {
              startTime: Number(startTime),
              endTime: Number(endTime),
              name:
                element.creator_name +
                '预约了' +
                element.estimate_start_time +
                '~~~' +
                element.estimate_end_time,
              tap: element
            }
            dtays.push(ss)
            // for (let index = 0; index < response.data.meetings.length; index++) {
            //   const element = response.data.meetings[index]
            //   let endinde = element.estimate_end_time.indexOf(':')
            //   let endTime =
            //     element.estimate_end_time.slice(endinde - 2, endinde) +
            //     element.estimate_end_time.slice(endinde + 1, endinde + 3)
            //   let startTime =
            //     element.estimate_start_time.slice(endinde - 2, endinde) +
            //     element.estimate_start_time.slice(endinde + 1, endinde + 3)
            //   let ss = {
            //     startTime: Number(startTime),
            //     endTime: Number(endTime),
            //     name:
            //       element.creator_name +
            //       '预约了' +
            //       element.estimate_start_time +
            //       '~~~' +
            //       element.estimate_end_time,
            //     tap: element
            //   }
            //   dtays.push(ss)
          }
          this.up(dtays)
        })
        .catch(err => {
          console.log(err)
        })
    },
    formatComparedTime(item) {
      const timeLength = this.comparedTime.length
      if (
        timeLength === 0 ||
        (timeLength === 1 && item.id > this.comparedTime[0].id)
      ) {
        this.comparedTime.push(item)
      } else if (timeLength === 1 && item.id < this.comparedTime[0].id) {
        // const oldComparedTime1 = deepClone(this.comparedTime)
        // this.comparedTime[0] = item
        // this.comparedTime[1] = oldComparedTime1[0]
        this.comparedTime.push(item)
      } else {
        // 第二次选择在原选择的右边
        if (item.id > this.comparedTime[1].id) {
          this.comparedTime[1] = item
          console.log('右边')
        }
        // 第二次选择在原选择的中间
        if (
          item.id < this.comparedTime[1].id &&
          item.id > this.comparedTime[0].id
        ) {
          this.comparedTime[1] = item
        }

        // 第二次选择在原选择的左边
        if (item.id < this.comparedTime[0].id) {
          const oldComparedTime2 = deepClone(this.comparedTime)
          this.comparedTime[0] = item
          this.comparedTime[1] = oldComparedTime2[1]
        } else if (item.id === this.comparedTime[0].id) {
          // 第二次选择跟第一次重叠
          this.comparedTime = []
          // this.comparedTime.push(item)
        }
      }
      if (
        this.comparedTime.length === 2 &&
        this.comparedTime[0].id > this.comparedTime[1].id
      ) {
        const oldComparedTime3 = deepClone(this.comparedTime) // 深拷贝
        this.comparedTime[0] = oldComparedTime3[1]
        this.comparedTime[1] = oldComparedTime3[0]
      }
    },
    handleTime(item, index) {
      if (item.isClick) {
        return
      }
      console.log(item)
      console.log(index)
      this.formatComparedTime(item)
      console.log('校验', this.comparedTime)
      for (let i = 0; i < this.meetTime.length; i++) {
        if (this.comparedTime.length === 1 && i === index) {
          this.meetTime[i].isSelect = true
          // break
        } else {
          if (
            this.comparedTime.length === 2 &&
            this.meetTime[i].id >= this.comparedTime[0].id &&
            this.meetTime[i].id <= this.comparedTime[1].id
          ) {
            if (this.meetTime[i].isClick) {
              if (this.comparedTime[1].id > this.meetTime[i].id) {
                this.$message.error('请选择正确时间段')

                console.log(this.meetTime[i].id)
                console.log(this.comparedTime[0].id)

                return
              }
            }
            this.meetTime[i].isSelect = true
          } else {
            this.meetTime[i].isSelect = false
          }
        }
      }
      // 处理已选中的数据，拿第一位和最后一位
      const cloneMeetTime = deepClone(this.meetTime)
      const formatMeetTime = cloneMeetTime.filter(v => {
        if (v.isSelect) {
          return v
        }
      })
      formatMeetTime.sort(this.sortId)
      if (formatMeetTime.length > 0) {
        const selectTime = {
          startTime: this.data + ' ' + formatMeetTime[0].start,
          endTime:
            this.data + ' ' + formatMeetTime[formatMeetTime.length - 1].end
        }
        this.$emit('reload', selectTime)
      } else {
        this.$emit('reload', '')
      }
    },
    sortId(a, b) {
      return a.id - b.id
    }
  }
}
</script>
<style scoped>
.cente .cente_span {
  line-height: 1.7;
  display: block;
}

.dateBox {
  margin-bottom: 10px;
}

.dateBox .el-input__inner {
  font-weight: 700;
}

.dateBox .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 140px;
}

.fontsize14 {
  font-size: 14px;
}

.grid-content {
  /* min-width: 970px; */
}

.grid-content ul li {
  width: 30px;
  height: 30px;
  list-style: none;
  background: #eee;
}

.bg {
  background: rebeccapurple !important;
}

ul {
  padding: 0;
  margin: 0;
}

.demo-form-inline {
  margin-top: 10px;
}
</style>
